__turbopack_context__.v({
  "legalLink": "LegalLinks-module__a6wzeG__legalLink",
  "legalLinksContainer": "LegalLinks-module__a6wzeG__legalLinksContainer",
});
